module.exports = __webpack_public_path__ + "img/python.9ae7d0c2.png";